module.exports = __webpack_public_path__ + "fhu.35a2b6faa5cd29f6ee05a62757e06d1e.png";